(() => {
  const plainClick = event => event.button === 0 && !event.metaKey && !event.ctrlKey && !event.altKey && !event.shiftKey;

  function updateImage(image, source, alt, animationTarget) {
    if (!image || !source) return;
    image.removeAttribute('srcset');
    if (window.VyborMotion?.swapImage) window.VyborMotion.swapImage(image, source, alt, animationTarget);
    else { image.src = source; image.alt = alt; }
  }

  function initCards(scope) {
    scope.querySelectorAll('[data-product-card]').forEach(card => {
      if (card.dataset.studioReady) return;
      card.dataset.studioReady = 'true';
      card.querySelectorAll('[data-card-swatch]').forEach(swatch => {
        swatch.addEventListener('click', event => {
          if (!plainClick(event) || !swatch.dataset.back) return;
          event.preventDefault();
          const media = card.querySelector('.product-image-button');
          const back = card.querySelector('.back-image');
          let front = card.querySelector('.front-image');
          updateImage(back, swatch.dataset.back, swatch.dataset.alt, media);
          if (swatch.dataset.front && !front && back) {
            front = back.cloneNode(false);
            front.className = 'front-image';
            front.alt = '';
            front.loading = 'lazy';
            media.append(front);
          }
          if (front) {
            front.hidden = !swatch.dataset.front;
            updateImage(front, swatch.dataset.front || swatch.dataset.back, '', media);
          }
          media.classList.toggle('has-front-image', Boolean(swatch.dataset.front));
          card.querySelectorAll('[data-card-link]').forEach(link => { link.href = swatch.href; });
          const price = card.querySelector('[data-card-price]');
          if (price) price.textContent = swatch.dataset.price;
          const colour = card.querySelector('[data-card-colour]');
          if (colour) colour.textContent = swatch.dataset.colour;
          const availability = card.querySelector('[data-card-unavailable]');
          if (availability) availability.hidden = swatch.dataset.available === 'true';
          card.querySelectorAll('[data-card-swatch]').forEach(item => {
            const active = item === swatch;
            item.classList.toggle('active', active);
            if (active) item.setAttribute('aria-current', 'true');
            else item.removeAttribute('aria-current');
          });
        });
      });
    });
  }

  function initEdit(scope) {
    scope.querySelectorAll('[data-studio-edit]').forEach(section => {
      if (section.dataset.studioReady) return;
      section.dataset.studioReady = 'true';
      const cards = [...section.querySelectorAll('[data-product-card]')];
      const typeLinks = [...section.querySelectorAll('[data-edit-filter]')];
      const collection = section.querySelector('[data-edit-collection]');
      let activeType = 'all';
      section.querySelectorAll('[data-enhanced-control]').forEach(control => { control.hidden = false; });
      function filter() {
        const group = collection?.value || 'all';
        const visible = [];
        window.VyborMotion?.forget?.(cards);
        cards.forEach(card => {
          const match = (activeType === 'all' || card.dataset.cardType === activeType) && (group === 'all' || card.dataset.cardCollection === group);
          card.hidden = !match;
          if (match) visible.push(card);
        });
        const count = section.querySelector('[data-edit-count]');
        if (count) count.textContent = section.dataset.countTemplate.replace('__COUNT__', visible.length);
        const empty = section.querySelector('[data-edit-empty]');
        if (empty) empty.hidden = visible.length > 0;
        window.VyborMotion?.reveal?.(visible);
      }
      typeLinks.forEach(link => link.addEventListener('click', event => {
        if (!plainClick(event)) return;
        event.preventDefault();
        activeType = link.dataset.editFilter;
        typeLinks.forEach(item => {
          item.classList.toggle('active', item === link);
          if (item === link) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
        filter();
      }));
      collection?.addEventListener('change', filter);
    });
  }

  function initialize(scope = document) { initCards(scope); initEdit(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
